import axios from '../Backend';


export const openContactOnCrm = async (id) => {
    try {
        const res = await axios.get(`/api/v2/crms/${id}`);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Unknown Error')
    } catch (e) {
        console.log('openContactOnCrm :: Error')
        console.log(JSON.stringify(e))
        if (e.response) {
            console.log('openContactOnCrm :: Response Error')
            console.log(JSON.stringify(e.response.data))
        }
        throw e
    }
}

export const openContactOnCrmAlways = async (crmId, phoneNumber) => {
    try {
      const finalId = crmId || 'null';
      let url = `/api/v2/crms/${finalId}`;
      if (phoneNumber) {
        url += `?channelNum=${phoneNumber}`;
      }
  
      const res = await axios.get(url);
      const resData = res.data;
      if (resData.status !== 'success') {
        throw new Error('Unknown Error');
      }
    } catch (e) {
      console.log('openContactOnCrm :: Error', e);
      if (e.response) {
        console.log('openContactOnCrm :: Response Error', e.response.data);
      }
      throw e;
    }
  };
